/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ correct: NonNullable<unknown>, total: NonNullable<unknown> }} Game_Daily_Complete_ShortInputs */

const bn_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`দৈনিক সম্পূর্ণ: ${i?.correct}/${i?.total}`)
};

const de_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Täglich abgeschlossen: ${i?.correct}/${i?.total}`)
};

const el_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Καθημερινή ολοκλήρωση: ${i?.correct}/${i?.total}`)
};

const en_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Daily complete: ${i?.correct}/${i?.total}`)
};

const es_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diario completo: ${i?.correct}/${i?.total}`)
};

const fr_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quotidien terminé : ${i?.correct}/${i?.total}`)
};

const hi_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`दैनिक पूर्ण: ${i?.correct}/${i?.total}`)
};

const hu_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Napi kész: ${i?.correct}/${i?.total}`)
};

const id_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selesai harian: ${i?.correct}/${i?.total}`)
};

const it_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Completo giornaliero: ${i?.correct}/${i?.total}`)
};

const ja_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`毎日の完了: ${i?.correct}/${i?.total}`)
};

const ko_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`일일 완료: ${i?.correct}/${i?.total}`)
};

const nl_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dagelijks compleet: ${i?.correct}/${i?.total}`)
};

const pl_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dzienne wykonanie: ${i?.correct}/${i?.total}`)
};

const pt_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Concluído diariamente: ${i?.correct}/${i?.total}`)
};

const ru_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Завершение за день: ${i?.correct}/${i?.total}`)
};

const sv_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dagligen klar: ${i?.correct}/${i?.total}`)
};

const tr_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Günlük tamamlama: ${i?.correct}/${i?.total}`)
};

const uk_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Виконано щодня: ${i?.correct}/${i?.total}`)
};

const vi_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoàn thành hàng ngày: ${i?.correct}/${i?.total}`)
};

const zh_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每日完成：${i?.correct}/${i?.total}`)
};

const zh_hant_game_daily_complete_short = /** @type {(inputs: Game_Daily_Complete_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每日完成：${i?.correct}/${i?.total}`)
};

/**
* | output |
* | --- |
* | "Daily complete: {correct}/{total}" |
*
* @param {Game_Daily_Complete_ShortInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_daily_complete_short = /** @type {((inputs: Game_Daily_Complete_ShortInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Daily_Complete_ShortInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_daily_complete_short(inputs)
	if (locale === "de") return de_game_daily_complete_short(inputs)
	if (locale === "el") return el_game_daily_complete_short(inputs)
	if (locale === "en") return en_game_daily_complete_short(inputs)
	if (locale === "es") return es_game_daily_complete_short(inputs)
	if (locale === "fr") return fr_game_daily_complete_short(inputs)
	if (locale === "hi") return hi_game_daily_complete_short(inputs)
	if (locale === "hu") return hu_game_daily_complete_short(inputs)
	if (locale === "id") return id_game_daily_complete_short(inputs)
	if (locale === "it") return it_game_daily_complete_short(inputs)
	if (locale === "ja") return ja_game_daily_complete_short(inputs)
	if (locale === "ko") return ko_game_daily_complete_short(inputs)
	if (locale === "nl") return nl_game_daily_complete_short(inputs)
	if (locale === "pl") return pl_game_daily_complete_short(inputs)
	if (locale === "pt") return pt_game_daily_complete_short(inputs)
	if (locale === "ru") return ru_game_daily_complete_short(inputs)
	if (locale === "sv") return sv_game_daily_complete_short(inputs)
	if (locale === "tr") return tr_game_daily_complete_short(inputs)
	if (locale === "uk") return uk_game_daily_complete_short(inputs)
	if (locale === "vi") return vi_game_daily_complete_short(inputs)
	if (locale === "zh") return zh_game_daily_complete_short(inputs)
	return zh_hant_game_daily_complete_short(inputs)
});